/*
* @描述: 新建回款
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/13 20:50
*/
<template>
    <van-popup v-model.sync="dialogVisible"
               :style="{ width: '100%',height: '100%' }">
        <div v-loading="loading" class="public_container">
            <div class="returnNavBar">
                <ReturnNavBar :isAllFunctions="false"
                              :isCustomReturnEvent="true"
                              :isTitleNormal="true"
                              title="返回"
                              @returnEvent="handleDialogClose"></ReturnNavBar>
            </div>
            <div class="detail_wrap_container">
                <van-form ref="repaymentForm"
                          error-message-align="right"
                          input-align="right"
                          label-width="10em"
                          scroll-to-error>
                    <div class="m_page_little_title">
                        <span class="title">订单信息</span>
                    </div>
                    <van-field v-model="repaymentForm.order_num"
                               :is-link="source!=='detail'"
                               label="关联订单"
                               name="order_num"
                               :rules="repaymentFormRules.order_num"
                               placeholder="请选择关联订单"
                               readonly
                               required
                               @click="handleOrderSelectFocus">
                    </van-field>
                    <van-field v-model="orderDetailsData.total_price"
                               disabled
                               label="订单金额"
                               name="total_price"
                               placeholder="自动带出">
                    </van-field>
                    <van-field v-model="orderDetailsData.contact_name"
                               disabled
                               label="客户联系人"
                               name="contact_name"
                               placeholder="自动带出">
                    </van-field>
                    <van-field v-model="orderDetailsData.salesperson_name"
                               disabled
                               label="销售"
                               name="salesperson_name"
                               placeholder="自动带出">
                    </van-field>
                    <div class="m_page_little_title">
                        <span class="title">回款信息</span>
                    </div>
                    <van-field :is-link="relateCustomList.length>0"
                               :value="repaymentForm.payment_company_name"
                               label="回款公司"
                               name="payment_company_name"
                               placeholder="请选择回款公司"
                               readonly
                               required
                               @click="showRelateCustomPicker=true">
                    </van-field>
                    <van-field :rules="repaymentFormRules.payment_date"
                               :value="repaymentForm.payment_date"
                               is-link
                               label="回款日期"
                               name="payment_date"
                               placeholder="请选择回款日期"
                               readonly
                               required
                               @click="showDateCalendar=true">
                    </van-field>
                    <van-field
                            :rules="repaymentFormRules.payment_method"
                            :value="repaymentForm.payment_method?paymentMethodColumns.find(item=>item.value===repaymentForm.payment_method).text:''"
                            is-link
                            label="回款方式"
                            name="payment_method"
                            placeholder="请选择回款方式"
                            readonly
                            required
                            @click="showRadioMethodPicker=true">
                    </van-field>
                    <van-field v-model="repaymentForm.repay_amount"
                               :rules="repaymentFormRules.repay_amount"
                               label="本次回款金额"
                               name="repay_amount"
                               placeholder="请输入本次回款金额"
                               required
                               @blur="handleInvoiceAmountInputBlur">
                    </van-field>
                    <div class="vertical_input_wrap">
                        <van-field v-model="repaymentForm.remark"
                                   autosize
                                   class="vertical_input_wrap"
                                   label="备注"
                                   name="remark"
                                   placeholder="请输入备注信息"
                                   type="textarea">
                        </van-field>
                    </div>
                    <div class="vertical_input_wrap">
                        <van-field label="附件"
                                   name="attachments"
                                   readonly>
                            <template #input>
                                <div class="m_file_outer_wrap">
                                    <p v-if="repaymentForm.attachments.length === 0" class="file_type_hint">
                                        支持Word、Excel、PDF等常见类型</p>
                                    <ul v-else class="m_upload_file_list">
                                        <li v-for="(file,file_idx) in repaymentForm.attachments"
                                            class="upload_file_item">
                                            <div class="file_left_wrap">
                                                <div class="file_info_wrap">
                                                    <p class="file_name" v-text="file.file_name"></p>
                                                </div>
                                            </div>
                                            <div class="file_right_wrap">
                                                <el-tooltip content="预览"
                                                            effect="dark"
                                                            placement="top">
                                                            <span class="handle_icon_wrap"
                                                                  @click="handleClickPreview(file)">
                                                                <i class="iconfont icon-yanjing"></i>
                                                            </span>
                                                </el-tooltip>
                                                <span class="line"></span>
                                                <el-tooltip content="删除"
                                                            effect="dark"
                                                            placement="top">
                                                    <span class="handle_icon_wrap handle_icon_danger_wrap"
                                                          @click="repaymentForm.attachments.splice(file_idx,1)">
                                                        <i class="iconfont icon-shanchu1"></i>
                                                    </span>
                                                </el-tooltip>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="m_upload_file_btn">
                                        <input class="upload_input"
                                               multiple
                                               type="file"
                                               @change="handleUploadFileChange($event)">
                                        <el-link :underline="false" type="primary">
                                            <i class="iconfont icon-shangchuan"></i> 上传附件
                                        </el-link>
                                    </div>
                                </div>
                            </template>
                        </van-field>
                    </div>
                </van-form>
            </div>
            <div class="add_footer_wrap">
                <van-button size="large"
                            type="primary"
                            @click="handleClickConfirm">提交
                </van-button>
            </div>
            <el-image ref="preview_img"
                      :preview-src-list="previewImgList"
                      :src="previewImgSrc"
                      style="display:none">
            </el-image>
            <van-calendar v-model="showDateCalendar"
                          :max-date="dateCalendarMax"
                          :min-date="dateCalendarMin"
                          :show-confirm="false"
                          color="#2990FF"
                          @confirm="handleDateCalenderConfirm"/>
            <van-popup v-model="showRadioMethodPicker" position="bottom" round>
                <van-picker
                        :columns="paymentMethodColumns"
                        show-toolbar
                        @cancel="showRadioMethodPicker = false"
                        @confirm="onPaymentMethodConfirm"/>
            </van-popup>
            <van-popup v-model="showRelateCustomPicker" position="bottom" round>
                <van-picker
                        :columns="relateCustomList"
                        show-toolbar
                        value-key="name"
                        @cancel="showRelateCustomPicker = false"
                        @confirm="onRelateCustomConfirm"/>
            </van-popup>
            <RelateOrderSelect v-if="selectOrderDialog"
                               :dialog-visible.sync="selectOrderDialog"
                               :projectId="projectId"
                               @success="handleClickOrderRow"/>
        </div>
    </van-popup>
</template>
<script>
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatDate, formatFileSize, getNowDate} from "@/utils";
import {invoiceInfoByOrder, orderCreateRepay, orderDetail, ReceivableDetail} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import RelateOrderSelect from "../component/relate_order_selet_popup";

export default {
    name: "RepaymentDialog",
    data() {
        return {
            repaymentForm: {
                order_num: "", // 订单编号
                payment_company_name: "",
                salesperson: 0, //销售人员UID (订单负责人UID)
                payment_date: "", //本次回款时间，格式：YYYY-MM-DD 必传的
                payment_method: '', //：1 电汇, 2 微信, 3 支付宝, 4 现金, 5 银行承兑, 6 商业承兑, 7 支票
                repay_amount: '', //本次回款金额
                remark: "", //备注
                attachments: []  //附件，JSON 数组
            },
            repaymentFormRules: {
                order_num: [{required: true, message: '请选择关联订单', trigger: 'onChange'}],
                payment_company_name: [{required: true, message: '请选择回款公司', trigger: 'onChange'}],
                payment_date: [{required: true, message: '请选择回款时间', trigger: 'onChange'}],
                payment_method: [{required: true, message: '请选择回款方式', trigger: 'onChange'}],
                repay_amount: [{required: true, message: '请输入回款金额', trigger: 'onBlur'}],
            },
            orderDetailsData: {
                total_price: '',
                contact_name: '',
                salesperson_name: '',
            },
            loading: false,
            selectOrderDialog: false,
            previewImgSrc: '',
            previewImgList: [],
            relateCustomList: [],
            showDateCalendar: false,
            dateCalendarMin: new Date('1970-01-01'),
            dateCalendarMax: new Date('2070-01-01'),
            showRadioMethodPicker: false,
            paymentMethodColumns: [
                {text: '电汇', value: 1},
                {text: '微信', value: 2},
                {text: '支付宝', value: 3},
                {text: '现金', value: 4},
                {text: '银行承兑', value: 5},
                {text: '商业承兑', value: 6},
                {text: '支票', value: 7},
            ],
            showRelateCustomPicker: false,
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: [Number, String],
            default: 0,
        },
        source: {
            type: String,
            default: 'list'
        },
        receivable_no: {
            type: String,
            default: ''
        },
        projectId: {
            type: Number,
            default: 0,
        }, //项目id
    },
    created() {
        if (this.order_id && this.source === 'detail') {
            this.getOrderDetail()
        }
        if (this.receivable_no) {
            this.getReceivableDetail()
        }
        this.repaymentForm.payment_date = getNowDate()
    },
    components: {ReturnNavBar, RelateOrderSelect},
    mounted() {
    },
    methods: {
        //获取订单详情
        getOrderDetail() {
            this.loading = true
            orderDetail({
                order_id: this.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData.total_price = res.data.total_price.value
                    this.orderDetailsData.salesperson_name = res.data.salesperson.text[0].name
                    this.repaymentForm.order_num = res.data.order_num
                    this.repaymentForm.salesperson = res.data.salesperson.value[0]
                    this.repaymentForm.payment_company_name = res.data.customer_id.text
                    this.orderDetailsData.contact_name = res.data.contact_id.text[0].name
                    this.getRelateCustomList()
                } else {
                    this.$message.error(res.message)
                    this.loading = false
                }
            })
        },

        // 详情
        getReceivableDetail() {
            this.loading = true;
            ReceivableDetail({receivable_no: this.receivable_no}).then((res) => {
                if (res.code === 200) {
                    this.repaymentForm.payment_company_name = res.data.basic_info.payment_company_name;
                    this.repaymentForm.payment_method = res.data.basic_info.payment_method;
                    this.repaymentForm.repay_amount = res.data.basic_info.payment_amount;
                    this.repaymentForm.remark = res.data.basic_info.remark;
                    this.repaymentForm.attachments = res.data.basic_info.attachments;
                    this.getOrderDetail()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false;
            });
        },

        handleOrderSelectFocus() {
            this.selectOrderDialog = true
        },

        //点击切换关联客户
        handleInvoiceCompanySelect(item) {
            if (item.customer_contacts.length) {
                this.orderDetailsData.contact_name = item.customer_contacts[0].name
            }
        },

        //选择订单事件
        handleClickOrderRow(data) {
            this.repaymentForm.order_num = data.order_num
            this.repaymentForm.payment_company_name = data.customer_name
            this.orderDetailsData.total_price = data.total_price
            this.orderDetailsData.contact_name = data.contact_name
            this.orderDetailsData.salesperson_name = data.salesperson_name
            this.repaymentForm.salesperson = data.salesperson
            this.getRelateCustomList()
        },

        getRelateCustomList() {
            invoiceInfoByOrder({
                order_num: this.repaymentForm.order_num
            }).then(res => {
                if (res.code === 200) {
                    this.relateCustomList = res.data.customer_list
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            })
        },

        //本次回款金额输入框失焦事件
        handleInvoiceAmountInputBlur() {
            let val = this.repaymentForm.repay_amount.replace(/[^\d.\-]/g, '');
            let amount = val ? Math.abs(parseFloat(val)) : 0;
            this.repaymentForm.repay_amount = amount.toFixed(2);
        },

        //汇款日期确定事件
        handleDateCalenderConfirm(date) {
            this.repaymentForm.payment_date = formatDate(date)
            this.showDateCalendar = false
        },

        //支付方式选择确定事件
        onPaymentMethodConfirm(data) {
            this.repaymentForm.payment_method = data.value
            this.showRadioMethodPicker = false
        },

        //关联公司选择确定事件
        onRelateCustomConfirm(data) {
            this.repaymentForm.payment_company_name = data.name
            this.showRelateCustomPicker = false
            if (data.customer_contacts.length) {
                this.orderDetailsData.contact_name = data.customer_contacts[0].name
            }
        },

        //上传文件
        handleUploadFileChange(e) {
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                if (file.size > 50 * 1024 * 1024) return that.$message.error('附件大小不能超过50m')
                uploadImg(file, file.size).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.repaymentForm.attachments.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },

        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不允许预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
            this.$emit('update:receivable_no', '')
        },

        //确定事件
        handleClickConfirm() {
            this.$refs.repaymentForm.validate().then(() => {
                orderCreateRepay(this.repaymentForm).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('回款申请提交成功')
                        this.$emit('update:dialogVisible', false)
                        this.$emit('refresh')
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(error => {
                if (error.length) {
                    this.$toast.fail(error[0].message)
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>

</style>